import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Blog, Pagination } from "../../components/";
import SidebarOne from "../Sidebars/SidebarOne";
import blogdata from "../../data/blog.json";

// Function to create slug from title
const slugify = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // remove symbols
    .trim()
    .replace(/\s+/g, "-"); // replace spaces with -
};

const BlogOne = ({ className }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = blogdata.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className={`vs-blog-wrapper ${className || ""}`}>
      <div className="container">
        <div className="row gx-40">
          <div className="col-lg-8">
            {currentPosts.map((post) => {
              const slug = slugify(post.title);
              return (
                <Blog className="blog-single" key={slug}>
                  <Blog.Image path={`/blog/${slug}`} src={post.image} />
                  <Blog.Body>
                    <Blog.Meta>
                      <Link to={`/blog/${slug}`}>
                        <i className="far fa-calendar" />
                        {post.date}
                      </Link>
                      <Link to={`/blog/${slug}`}>
                        <i className="fal fa-user" />
                        {post.authorName}
                      </Link>
                    </Blog.Meta>
                    <Blog.Title path={`/blog/${slug}`}>
                      {post.title}
                    </Blog.Title>
                    <p>{post.text}</p>
                    <Link to={`/blog/${slug}`} className="link-btn">
                      Read Details <i className="far fa-arrow-right"></i>
                    </Link>
                  </Blog.Body>
                </Blog>
              );
            })}

            {/* ✅ Pagination Component */}
            <Pagination
              totalPosts={blogdata.length}
              postsPerPage={postsPerPage}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>

          <div className="col-lg-4">
            <SidebarOne />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogOne;
